export default "__VITE_ASSET__BUne2uWx__"